import React, { useEffect, useState } from 'react';
import { notification } from '../../hocs/notification';

import axios from 'axios';
import { mainurl } from '../../../Mainurl';

import { FaHeading } from 'react-icons/fa';
import { Row, Col, Card, CardBody, CardHeader, Form, FormGroup, Input, Label, InputGroup, InputGroupText, Spinner, Button } from 'reactstrap';

const AddEventSubject = ({ back }) => {
    const [loading, setLoading] = useState(false);
    const [desc, setdesc] = useState('');
    const [topic, setTopic] = useState('');
    const [topicOpt, setTopicOpt] = useState('');
    const [type, setType] = useState('');

    useEffect(() => {
        get_topic_list();
    }, [])

    const get_topic_list = () => {
        setTopicOpt('');
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "lang_id": 1 }];
        axios({
            method: 'post',
            url: mainurl + 'Master/box_event_subject_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.event_topic_id}> {row.topic_desc}</option>
                    )
                });

                setTopicOpt(list);

            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }


    const add_handler = (e) => {
        e.preventDefault();


        let postData = [{
            "org_id": sessionStorage.getItem('org_id'),
            "subject_desc": desc,
            "event_topic_id": topic,
            "event_type": type

        }];

        console.log(postData);
        axios({
            method: 'post',
            url: mainurl + 'Common/event_subject_add',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (response.data[0].retcode == 101) {
                    let notify = notification({ message: "Event Subject added Successfully.", type: 'info', time: true, position: 'center' });
                    notify();
                    back();
                }
            })
            .catch(error => {
                let notify = notification({ message: "Submit failed! Try Again", type: 'error', time: true });
                notify();
            });
    }

    return (
        <>
            <Card className='mb-3' color="primary" outline>
                <CardHeader> Add New Event Subject </CardHeader>
                <CardBody>
                    <Form onSubmit={add_handler}>

                        <FormGroup row>
                            <Label for="name" sm={2} > Topic </Label>
                            <Col sm={4}>
                                <Input id="type" bsSize="sm" type="select" value={topic} onChange={(e) => setTopic(e.target.value)}>
                                    <option value="0"> --Select Topic--</option>
                                    {topicOpt}
                                </Input>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="name" sm={2} > Type </Label>
                            <Col sm={4}>
                                <Input id="type" bsSize="sm" type="select" value={type} onChange={(e) => setType(e.target.value)}>
                                    <option value="0"> --Select Type--</option>
                                    <option value="1"> Training </option>
                                    <option value="2"> Meeting </option>
                                </Input>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="name" sm={2} > Subject Descripation </Label>
                            <Col sm={4}>
                                <Input id="name" type='text' bsSize="sm" value={desc} onChange={(e) => setdesc(e.target.value)} required />
                            </Col>
                        </FormGroup>
                        <Row>
                            <hr />
                            <Col md={2} className="mb-2">
                                <Button className='text-white' color='primary' size="sm" block> Submit </Button>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
            <div className='text-end'>
                <Button className='text-white' color='primary' size="sm" onClick={back}> Back </Button>
            </div>
        </>
    )
}

export default AddEventSubject;